import { sessionInterceptor } from './services/http-service/session.interceptor';
import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { App } from './app';
import { AppRoutingModule } from './app-routing-module';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';

@NgModule({
    declarations: [
        App,

    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        LayoutModule,
        PagesModule
    ],
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideAnimations(),
        provideHttpClient(withInterceptors([sessionInterceptor])),
    ],
    bootstrap: [App]
})
export class AppModule { }
